export default {
  intercomAppID: import.meta.env.VUE_APP_INTERCOM_APP_ID,
  intercomEnv: import.meta.env.VUE_APP_INTERCOM_ENV,
  googleAnalyticsToken: import.meta.env.VUE_APP_ANALYTICS_ID,
  googleAnalyticsAppName: import.meta.env.VUE_APP_GOOGLE_ANALYTICS_ID_TOKEN,
  googleAnalyticsAppVersion: import.meta.env.VUE_APP_GOOGLE_ANALYTICS_ID_TOKEN,
  logRocketID: import.meta.env.VUE_APP_LOG_ROCKET,
  appUrl: import.meta.env.VUE_APP_URL,
  segmentWriteKey: import.meta.env.VUE_APP_SEGMENT_WRITE_KEY,
  buildSHA: import.meta.env.VUE_APP_HASH,
  buildDateTime: import.meta.env.VUE_APP_HASH_DATE,
};
